import { api } from '@/lib/api-manager'

export async function getUniqueDesiredEducations(
  pageParam: number,
  term: string
) {
  const response = await api.get('v1/educations/desired-educations', {
    params: { pageParam, term }
  })

  return response.data
}
